import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VeeValidate, { Validator } from 'vee-validate'
import VueTheMask from 'vue-the-mask'

import moment from 'moment'
import router from './router'
import store from './store'
import App from './App.vue'

// Filters
import '@core/utils/filter'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

import Auth from './api/http/models/auth/Auth'

moment.locale('ru')

const ru = require('vee-validate/dist/locale/ru')

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(VeeValidate, {
  locale: 'ru',
  events: 'blur',
})
Vue.use(VueTheMask)
Validator.localize('ru', ru)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

function getCookie() {
  Auth.getCsrfCookie()
}

(async () => {
  // Получения куков
  await getCookie()

  // Получение текущего пользователя
  await store.dispatch('user/FETCH_CURRENT_USER')

  // Инициализация vue приложения
  await new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')

  // Автоматическое обновление куков каждые 30 мин
  setInterval(getCookie, 30 * 60000)
})()
